const AREA_OPTIONS = ['OTHER', 'CHN', 'XX', 'US'];

function normalizeFileName(name) {
  return String(name || '').trim();
}

function hasTxtExtension(name) {
  return /\.txt$/i.test(normalizeFileName(name));
}

function detectAreaToken(name) {
  const upperName = normalizeFileName(name).toUpperCase();
  return AREA_OPTIONS.find((area) => {
    return new RegExp(`(^|[^A-Z0-9])${area}([^A-Z0-9]|$)`).test(upperName);
  }) || '';
}

export function detectDeliverAreaFromFileName(name) {
  if (!hasTxtExtension(name)) {
    return '';
  }
  return detectAreaToken(name);
}

export function validateDeliverBatchFiles(files = []) {
  const accepted = [];
  const rejected = [];
  const seenAreas = new Set();

  Array.from(files || []).forEach((file) => {
    const name = normalizeFileName(file?.name);
    const area = detectAreaToken(name);

    if (!hasTxtExtension(name)) {
      rejected.push({ name, reason: 'invalid_extension', area });
      return;
    }

    if (!area) {
      rejected.push({ name, reason: 'unknown_area', area: '' });
      return;
    }

    if (seenAreas.has(area)) {
      rejected.push({ name, reason: 'duplicate_area', area });
      return;
    }

    seenAreas.add(area);
    accepted.push({ area, file });
  });

  return { accepted, rejected };
}

export function parseDeliverRedisValue(value) {
  const rawValue = String(value ?? '');
  const separatorIndex = rawValue.lastIndexOf('|');

  if (separatorIndex < 0) {
    return { deliver: rawValue, minClientVersion: '' };
  }

  const minClientVersion = rawValue.slice(separatorIndex + 1).trim();
  if (!/^V\d+\.\d+$/.test(minClientVersion)) {
    return { deliver: rawValue, minClientVersion: '' };
  }

  return {
    deliver: rawValue.slice(0, separatorIndex),
    minClientVersion,
  };
}

export function normalizeDeliverRedisKeysResult(result = {}) {
  const keys = Array.isArray(result?.keys) ? result.keys : [];
  return {
    ...result,
    keys: keys.map((row) => ({
      ...row,
      ...parseDeliverRedisValue(row?.value),
    })),
  };
}
